import styled from 'styled-components';

export const LogoWrap = styled.img`
  display: block;
  height: auto;
  width: 120px;
  text-align: center;
  margin: 22px auto 70px;
`;
